import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Login from "./component";
import { decryptURL, loginUserAndAuthenticate, updateUserId } from "./actions";
import {
  createContentMap,
  createExternalUserAccount,
  getAssessmentByAssessmentId,
  getContentLatestVersion,
} from "../signup/actions";
import {
  getOrderDataByUserId,
  updateGuestUser,
  isGuestOrPremiumUser,
} from "../settings/actions";
import {
  fetchAbTest,
  getAbTest,
  getAssessmentResultByAssessmentAttemptId,
} from "../plan/actions";
import {
  saveRelationshipCompatibilityResult,
  saveUserAssessmentResultMaps,
} from "../quiz/actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loginUserAndAuthenticateConnect: loginUserAndAuthenticate,
      updateUserIdConnect: updateUserId,
      createExternalUserAccountConnect: createExternalUserAccount,
      updateGuestUserConnect: updateGuestUser,
      decryptUrlConnect: decryptURL,
      getContentLatestVersionConnect: getContentLatestVersion,
      getAssessmentByAssessmentIdConnect: getAssessmentByAssessmentId,
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      createContentMapConnect: createContentMap,
      getOrderDataByUserIdConnect: getOrderDataByUserId,
      IsGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      saveRelationshipCompatibilityResultConnect:
        saveRelationshipCompatibilityResult,
      saveUserAssessmentResultMapsConnect: saveUserAssessmentResultMaps,
      fetchAbTestConnect: fetchAbTest,
      getAbTestConnect: getAbTest,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);
